module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-backplates-remnants.82fbb39c.png";